import { useState } from 'react';

const ContactSection = () => {
  const [formData, setFormData] = useState({ company: '', name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.message.length > 500) return;
    setSubmitting(true);
    const body = new URLSearchParams({
      company: formData.company,
      name: formData.name,
      email: formData.email,
      message: formData.message,
    });
    try {
      await fetch('https://readdy.ai/api/form/d7ab73ibdfubkqslaiig', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          <div className="w-full h-[300px] md:h-[420px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/4d4dd95c3a9aa22ce68cd3e2713d7c5c.jpg"
              alt="お問い合わせ"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-[#3d6b4f] text-xs font-semibold tracking-widest uppercase mb-3">Contact</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">お問い合わせ</h2>
            <p className="text-xs text-gray-500 leading-relaxed mb-2">
              弊社提供サービス、取材依頼などのお問い合わせは以下のフォームよりお願い致します。通常3営業日以内に担当者よりご連絡させていただきます。
            </p>
            <p className="text-xs text-gray-400 leading-relaxed mb-6">
              お問い合わせいただきました内容は、弊社の掲げる個人情報保護方針に沿って管理し、お客様の同意なく第三者に開示・提供することはございません。
              詳細につきましては、当サイトの「<a href="#privacy" className="text-[#3d6b4f] underline">プライバシーポリシー</a>」をご参照ください。
            </p>
            {submitted ? (
              <div className="bg-[#3d6b4f]/10 border border-[#3d6b4f]/30 rounded-lg p-6 text-center">
                <i className="ri-checkbox-circle-line text-[#3d6b4f] text-3xl mb-2 block"></i>
                <p className="text-sm font-semibold text-[#3d6b4f]">送信が完了しました</p>
                <p className="text-xs text-gray-500 mt-1">3営業日以内にご連絡いたします。</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input
                  type="text"
                  name="company"
                  placeholder="会社名 *"
                  required
                  value={formData.company}
                  onChange={handleChange}
                  className="border border-gray-200 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:border-[#3d6b4f] transition-colors"
                />
                <input
                  type="text"
                  name="name"
                  placeholder="氏名 *"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="border border-gray-200 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:border-[#3d6b4f] transition-colors"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="メールアドレス *"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="border border-gray-200 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:border-[#3d6b4f] transition-colors"
                />
                <div>
                  <textarea
                    name="message"
                    placeholder="お問い合わせ内容 *"
                    required
                    rows={4}
                    maxLength={500}
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm focus:outline-none focus:border-[#3d6b4f] transition-colors resize-none"
                  />
                  <p className="text-xs text-gray-400 text-right mt-1">{formData.message.length}/500</p>
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-[#3d6b4f] hover:bg-[#2f5540] text-white text-sm font-semibold py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {submitting ? '送信中...' : '送信'}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
